<template>
  <b-modal
    hide-footer
    id="modal-province-manage"
    ref="modal-province-manage"
    size="md"
    title="จัดการสิทธิ์จังหวัด"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12" class="mb-2">
            <h3>
              เจ้าหน้าที่: <span>{{ fullname }}</span>
            </h3>
          </b-col>
          <b-col cols="12">
            <b-form-group label="เขต">
              <vue-select
                transition=""
                label="text"
                v-model="areaSelect"
                :options="areaOptions"
                :clearable="false"
                @input="areaOnInput()"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="level > 1">
            <b-form-group label="จังหวัด">
              <vue-select
                transition=""
                label="text"
                v-model="provinceSelect"
                :options="provinceOptions"
                :clearable="false"                
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12">
            <b-form-group label="อำเภอ">
              <vue-select
                label="text"
                v-model="districtSelect"
                :options="districtOptions"
                :clearable="false"
                @input="areaOnInput()"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col> -->
          <!-- <b-col cols="12">
            <b-form-group label="ตำบล">
              <vue-select
                label="text"
                v-model="subDistrictSelect"
                :options="subDistrictOptions"
                :clearable="false"
                @input="areaOnInput()"
                class="mt-1 pl-1"
              />
            </b-form-group>
          </b-col> -->
        </b-row>
        <footer
          id="modal-transfer___BV_modal_footer_"
          class="modal-footer d-flex justify-content-between"
        >
          <button
            type="button"
            class="btn btn-secondary"
            block
            @click="onCancel"
          >
            ยกเลิก
          </button>
          <button type="button" class="btn btn-primary" block @click="onSubmit">
            บันทึก
          </button>
        </footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import * as storeMaster from "@/store/api/master/index.js";

import VueSelect from "vue-select";

import CommonTable from "./commonTableModal";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    VueSelect,
    CommonTable,
    BCard,
  },
  props: {},
  data() {
    return {
      level: 1,
      fullname: "",
      userId: null,
      areaCode: null,
      provinceCode: null,
      districtCode: null,
      subDistrictCode: null,
      areaSelect: null,
      provinceSelect: null,
      districtSelect: null,
      subDistrictSelect: null,
      areaOptions: [],
      provinceOptions: [],
      districtOptions: [],
      subDistrictOptions: [],
    };
  },
  created() {},
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    onShow(user, level) {
      const _this = this

      console.log(
        "onShow",
        user.fullname,
        user.area,
        user.province,
        user.district,
        user.subDistrict
      );

      this.level = level;
      this.fullname = user.fullname;
      this.userId = user.userId;
      this.areaCode = user.area;
      this.provinceCode = user.province;
      this.districtCode = user.district;
      this.subDistrictCode = user.subDistrict;

      this.initArea()
    },
    initArea() {
      const _this = this

      storeMaster
        .getArea()
        .then(function(response) {
          _this.areaOptions = response.data.data;
          // set userList default options
          _this.areaSelect = _this.areaOptions.find((value) => {
            return value.value === _this.areaCode
          })

          //console.log('this.areaCode', _this.areaCode)

          if (_this.areaCode !== null && _this.areaCode !== undefined) {
            _this.initProvince();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },

    initProvince() {

      const _this = this

      storeMaster
        .getProvinceByArea(_this.areaCode)
        .then(function(response) {
          _this.provinceOptions = response.data.data;
          // set userList default options
          _this.provinceSelect = _this.provinceOptions.find((value) => {
            return value.value === _this.provinceCode
          })

          if (_this.provinceCode !== null) {
            //_this.initDistrict();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    initDistrict() {

      const _this = this

      storeMaster
        .getDistrict(_this.provinceCode)
        .then(function(response) {
          _this.districtOptions = response.data.data;
          // set userList default options
          _this.districtSelect = _this.districtOptions.find((value) => {
            return value.value === _this.districtCode
          })

          if (_this.districtCode !== null) {
            _this.initSubDistrict();
          }
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    initSubDistrict() {

      const _this = this

      storeMaster
        .getSubDistrict(_this.districtCode)
        .then(function(response) {
          _this.subDistrictOptions = response.data.data;
          // set userList default options
          _this.subDistrictSelect = _this.subDistrictOptions.find((value) => {
            return value.value === _this.subDistrictCode
          })


        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    updateProvince() {
      storeMaster
        .getProvince()
        .then(function(response) {
          // handle success
          console.log("response", response);
          var localProvince = response.data.data;
          _this.provinces = response.data.data;

          // set userList default options
          users = users.map((value) => {
            var option = localProvince.find((prov) => {
              return prov.value === value.provinceCode;
            });

            value.province = option;

            //value.province = localProvince[0]
            return value;
          });

          //_this.$forceUpdate();

          //console.log('_this.rows', _this.rows)
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    onSubmit() {
      const data = {
        userId :this.userId,
        area :this.areaSelect !== null ? this.areaSelect.value : null,
        province: this.provinceSelect !== null ? this.provinceSelect?.value : null,
        district: this.districtSelect !== null ? this.districtSelect?.value : null,
        subDistrict: this.subDistrictSelect !== null ? this.subDistrictSelect?.value : null,
      }
      this.$emit("handle-submit", data);
    },
    onCancel() {
      this.$refs["modal-province-manage"].hide();
    },
    areaOnInput() {
      //console.log("areaOnInput", this.areaSelect);
      const _this = this

      if (_this.level > 1) {
        storeMaster
        .getProvinceByArea(_this.areaSelect.value)
        .then(function(response) {
          _this.provinceOptions = response.data.data;
          _this.provinceSelect = null
          // set userList default options          
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
      }

      
    },
  },
};
</script>

<style></style>
